import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  preamble: {
    marginTop: 0,
    marginBottom: theme.new.spacing.large,
  },
  list: {
    paddingLeft: theme.new.spacing.large,
    marginBottom: 0,
  },
  boldLink: {
    fontWeight: theme.typography.body_medium.fontWeight,
  },
}));

export default useStyles;
